import { TWidget } from 'widgets/Widget';
import { WishlistItemsMgr } from '../toolbox/wishlistItemsMgr';
import localStorageWrapper from 'widgets/toolbox/localStorageWrapper';

/**
 * @param Widget Base widget for extending
 * @returns Wishlist icon class
 */

export default function (Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory header
     * @class WishlistIcon
     * @augments Widget
     * @classdesc Wish list icon component with next features:
     * 1. Change state (color, label) of wishlist icon in the header
     */
    class WishlistIcon extends Widget {
        prefs() {
            return {
                wishlistIcon: 'wishlistIcon',
                getWishlistItemsUrl: '',
                labelNoItems: '',
                labelHasItems: '',
                classesAnimated: 'm-animated',
                ...super.prefs()
            };
        }

        /**
         * @description Add global event handlers
         */
        init(): void {
            super.init();

            if (!localStorageWrapper.getItem('currentSite')) {
                localStorageWrapper.setItem('currentSite', window.sfccData.siteData.id);
            }

            const wishlistItemsMgr = WishlistItemsMgr.getInstance();

            wishlistItemsMgr.isItemsInWishList()
                .then(state => this.changeStateWishListIcon(state, false));
            this.eventBus().on('product.addedToWishlist', 'changeStateWishListIcon');
            this.eventBus().on('product.removedFromWishlist', 'changeStateWishListIcon');
        }

        /**
         * @description Change state of wishlist icon in the header
         * @param isActive Indicates is button active or not
         * @param isAnimated Indicates is button animated or not
         */
        changeStateWishListIcon(isActive: boolean, isAnimated: (boolean|undefined)): void {
            if (localStorageWrapper.getItem('currentSite') !== window.sfccData.siteData.id) {
                localStorageWrapper.setItem('currentSite', window.sfccData.siteData.id);
            }

            this.ref('self')
                .toggleClass('m-active', Boolean(isActive))
                .attr('aria-label', isActive ? this.prefs().labelHasItems : this.prefs().labelNoItems);
            this.ref('self')
                .attr('title', isActive ? this.prefs().labelHasItems : this.prefs().labelNoItems);

            if (isActive && isAnimated) {
                this.ref('self').removeClass(this.prefs().classesAnimated);

                setTimeout(() => {
                    this.ref('self').addClass(this.prefs().classesAnimated);
                }, 100);
            }
        }
    }

    return WishlistIcon;
}
